import { useEffect } from 'react'
import posthog from 'posthog-js'
import { useParams } from 'react-router-dom'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'

interface ITransactionProps {
    data: IMoneyPoolTransaction | undefined
    isLoading: boolean
    isManager: boolean
    searchTrans: string
    setSearchtransaction: React.Dispatch<React.SetStateAction<string>>
    setSearchTrans: React.Dispatch<React.SetStateAction<string>>
    /** the #hashtag currently filtering the list, '' when there is none */
    hashtagFilter: string
    onHashtagClick: (hashtag: string) => void
    onClearHashtag: () => void
}
export default function Transactions({
    data,
    isLoading,
    isManager,
    searchTrans,
    setSearchtransaction,
    setSearchTrans,
    hashtagFilter,
    onHashtagClick,
    onClearHashtag,
}: ITransactionProps) {
    const { id } = useParams()
    const rows = data?.results?.result

    // What the hashtag search actually returned. Fired here rather than next to
    // the tap, because the tap only sets a `q=` — whether it found anything is
    // known one round trip later, and «تراکنشی با این هشتگ پیدا نشد» is the
    // outcome worth counting.
    useEffect(() => {
        if (hashtagFilter === '' || !rows) return
        posthog.capture('transaction_hashtag_search_results', {
            moneypool_id: Number(id),
            result_count: rows.length,
            is_empty: rows.length === 0,
        })
        // Keyed on the filter and the size of its answer, not on the array
        // identity, which changes on every background refetch.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hashtagFilter, rows?.length, id])

    if (isLoading || !rows) {
        return <DotsLoading />
    }

    return (
        <div className="min-h-full bg-white pt-2 pb-4">
            {/* The active hashtag filter. Shown above the rows rather than as
                a toast, because a list that silently holds a filter is a list
                people read as "my transactions disappeared". */}
            {hashtagFilter !== '' && (
                <div className="mx-4 mb-2 flex items-center justify-between gap-2 rounded-[10px] bg-blue-6 px-3 py-2">
                    <p className="truncate text-sm text-blue-5">
                        تراکنش‌های{' '}
                        <span className="font-bold">{hashtagFilter}</span>
                    </p>
                    <button
                        type="button"
                        onClick={onClearHashtag}
                        className="shrink-0 text-sm font-bold text-blue-5"
                    >
                        حذف فیلتر
                    </button>
                </div>
            )}

            {rows.length === 0 ? (
                <p className="mt-2.5 text-center text-sm text-text-body">
                    {hashtagFilter !== ''
                        ? 'تراکنشی با این هشتگ پیدا نشد'
                        : 'تراکنشی وجود ندارد'}
                </p>
            ) : (
                rows.map((item) => (
                    <Item
                        item={item}
                        key={item.id}
                        isManager={isManager}
                        onHashtagClick={onHashtagClick}
                    />
                ))
            )}
        </div>
    )
}
